import axios from 'axios'

export const transformInputToGeocoding = async (locationString, token) => {
  const url = process.env.GATSBY_API_MARKET_SEARCH
  const headers = { Authorization: `Bearer ${token}` }
  const params = {
    op: 'getGeoLocation',
    address: locationString,
    language: 'DE',
    region: 'de'
  }

  const { data } = await axios({
    method: 'get',
    url,
    headers,
    params
  })

  return data
}
